import { render, staticRenderFns } from "./LoginLink.vue?vue&type=template&id=2db02970&"
import script from "./LoginLink.vue?vue&type=script&lang=js&"
export * from "./LoginLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports